import type { Board, TaskCard } from "@maestros/contracts";

/** Execution comes from the attempt DTO, never from a task column or project state. */
export function activeAttempt(task: TaskCard) {
  const attempt = task.current_attempt;
  return attempt?.state === "running" || attempt?.state === "waiting_resource" ? attempt : null;
}

export function executionFacts(board: Board | undefined) {
  const tasks = board ? [...board.columns.flatMap((c) => c.tasks), ...board.side_lane.flatMap((s) => s.tasks)] : [];
  return {
    running: tasks.filter((task) => activeAttempt(task)?.state === "running").length,
    waiting: tasks.filter((task) => activeAttempt(task)?.state === "waiting_resource").length,
    unknown: !board || tasks.some((task) => task.current_attempt === undefined),
  };
}
